import axios from "../../../lib/axios";
import React, { useEffect, useState } from "react";
import { SuppliesMainGroupName } from "../../../models/suppliesMain";
import {
  MASTER_MAIN_GROUP_FIND_MANY,
  MASTER_MAIN_GROUP_DELETE,
  MAIN_GROUP_FIND_MANY,
  MAIN_GROUP_DELETE,
} from "../../../lib/endpoints/category";
import { MerChantModel } from "../../../models/merChantModel";
import { MERCHANT_STORE_FIND_MANY } from "../../../lib/endpoints/merchant";
import { MainGroupModel } from "../../../models/mainGroup";
import { MerchantUserModel } from "../../../models/merchantUser";
import { RootState } from "../../../store";
import { useSelector } from "react-redux";

const useCategoryController = () => {
  const [data, setData] = useState<SuppliesMainGroupName[]>([]);
  const authData: MerchantUserModel = useSelector(
    (state: RootState) => state?.auth?.data ?? null!
  );

  const [dataMainGroup, setDataMainGroup] = useState<MainGroupModel[]>([]);
  const [dataMasterMainGroup, setDataMasterMainGroup] = useState<
    SuppliesMainGroupName[]
  >([]);

  const [selectedMainGroup, setSelectedMainGroup] = useState<MainGroupModel>(
    null!
  );
  const [selectedDeleteId, setSelectedDeleteId] = useState<string>("");
  const [selectedMainCategoryId, setSelectedMainCategoryId] =
    useState<SuppliesMainGroupName>(null!);
  const [openDeleteForm, setOpenDeleteForm] = useState<boolean>(false);
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [openMainCategory, setOpenMainCategory] = useState<boolean>(false);

  const [loadingButtonDelete, setLoadingButtonDelete] =
    useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [searchValue, setSearchValue] = useState<string>("");

  const handleFetchDataMainCategory = async () => {
    try {
      setLoading(true);
      const resMasterMainGroup = await axios.post(MASTER_MAIN_GROUP_FIND_MANY);
      setDataMasterMainGroup(resMasterMainGroup?.data);
      const res = await axios.post(MAIN_GROUP_FIND_MANY, {
        filter: {
          merchant_id: authData?.merchantId,
        },
      });
      setDataMainGroup(res?.data?.data);
    } catch (err) {
    } finally {
      setLoading(true);
    }
  };

  const handleGetDataMainGroup = async () => {
    try {
      setLoading(true);

      const resMasterMainGroup = await axios.post(MASTER_MAIN_GROUP_FIND_MANY);
      setDataMasterMainGroup(resMasterMainGroup?.data);
      const res = await axios.post(MAIN_GROUP_FIND_MANY, {
        filter: {
          merchant_id: authData?.merchantId,
        },
      });
      setDataMainGroup(res?.data?.data);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoadingButtonDelete(true);
    try {
      await axios.delete(`${MAIN_GROUP_DELETE}?id=${selectedDeleteId}`);
      // await handleFetchDataMainCategory();
      setDataMainGroup(
        dataMainGroup?.filter((item) => item?.id !== selectedDeleteId)
      );
    } catch (err: any) {
      try {
        window.alert(err.response.data.message);
      } catch (err2) {
        window.alert("Server error please try again");
      }
    } finally {
      setLoadingButtonDelete(false);
      handleCloseDeleteForm();
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleOpenEdit = (id: string) => {
    setOpenMainCategory(true);
    const getEditData: SuppliesMainGroupName = data.filter(
      (item) => item.id === id
    )[0];
    setSelectedMainCategoryId(getEditData);
  };

  const handleOpenDelete = (id: string) => {
    setOpenDeleteForm(true);
    setSelectedDeleteId(id);
  };

  const handleCloseDeleteForm = () => {
    setOpenDeleteForm(false);
  };

  const handleOpenAddCategory = () => {
    setOpenMainCategory(!openMainCategory);
  };
  const handleCloseAddCategory = () => {
    setOpenMainCategory(false);
  };

  const handleOpenForm = (id: string) => {
    setOpenForm(!openForm);
    const selectedData = dataMainGroup.filter((item) => item.id === id)[0];
    setSelectedMainGroup(selectedData);
  };
  const handleCloseForm = () => {
    setOpenForm(false);
  };

  const handleRefetchData = async () => {
    const res = await axios.post(MAIN_GROUP_FIND_MANY, {
      filter: {
        merchant_id: authData?.merchantId,
      },
    });
    setDataMainGroup(res?.data?.data);
  };

  useEffect(() => {
    console.log("loading=", loading);
  }, [loading]);

  //filter Data
  const filterData: MainGroupModel[] = dataMainGroup;

  const isSearchNotFound: boolean = !filterData.length && !!searchValue;

  useEffect(() => {
    handleGetDataMainGroup();
  }, []);

  return {
    loadingButtonDelete,
    handleDelete,
    handleOpenDelete,
    openDeleteForm,
    handleCloseDeleteForm,
    openForm,
    handleCloseForm,
    handleOpenForm,
    loading,
    openMainCategory,
    handleOpenAddCategory,
    handleCloseAddCategory,
    selectedDeleteId,
    selectedMainGroup,
    searchValue,
    handleSearch,
    filterData,
    isSearchNotFound,
    handleOpenEdit,
    handleFetchDataMainCategory,
    selectedMainCategoryId,
    onSetSelectedMain: (newValue: SuppliesMainGroupName) =>
      setSelectedMainCategoryId(newValue),
    dataMainGroup,
    dataMasterMainGroup,
    handleRefetchData,
    merchant:authData?.merchantId
  };
};
export default useCategoryController;
